import '../scss/main.scss';
import { HeaderNav } from '@components/HeaderNav';
import { HeaderBanner } from '@components/HeaderBanner';

function mountHeaderPreview() {
	const host = document.querySelector('.hp-header-host');
	const template = document.getElementById('hp-header-template');
	if (!host || !template || !host.attachShadow) return;

	// Moved out of <body> so that pushing the page left (a transform on <body>,
	// see HeaderNav's drawer) can never drag our own fixed header/drawer along with it —
	// a transformed ancestor becomes the containing block for its fixed descendants.
	document.documentElement.appendChild(host);

	const shadow = host.attachShadow({ mode: 'open' });

	const mountContent = () => {
		shadow.appendChild(template.content.cloneNode(true));
		new HeaderNav(shadow).init();
		new HeaderBanner(shadow).init();
	};

	if (window.hpHeaderData && window.hpHeaderData.styleUrl) {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = window.hpHeaderData.styleUrl;
		// Only mount the markup once its stylesheet has actually loaded — otherwise it
		// briefly renders unstyled and visibly "jumps" once the CSS catches up.
		link.addEventListener('load', mountContent);
		link.addEventListener('error', mountContent);
		shadow.appendChild(link);
	} else {
		mountContent();
	}
}

document.addEventListener('DOMContentLoaded', () => {
	mountHeaderPreview();
});
